import React, { useState } from "react";
import validateForm from "../utils/formValidation";
import emailjs from '@emailjs/browser';



function AppointmentForm() {
	const [formData, setFormData] = useState({ name: "", email: "", phone: "", date: "" });
	const [submitted, setSubmitted] = useState(false);
	const [error, setError] = useState("");

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		setError("");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (validateForm(formData)) {
			setSubmitted(true);
			setError("");
			// EmailJS integration
			emailjs.send(
				'service_iwhdf2s', // your EmailJS service ID
				'template_8rw8on8', // your EmailJS template ID
				{
					name: formData.name,
					email: formData.email,
					phone: formData.phone,
					date: formData.date,
					to_email: 'Biokaredental@gmail.com',
				},
				'HX2zmvAoHlZssK7YE' // your EmailJS public key
			)
			.then(() => {
				// Send auto-reply to customer
				emailjs.send(
					'service_iwhdf2s',
					'template_ia9mv2y', // auto-reply template ID
					{
						name: formData.name,
						to_email: formData.email,
					},
					'HX2zmvAoHlZssK7YE'
				);
				setSubmitted(true);
			}, (error) => {
				setError("Failed to send email. Please try again.");
				setSubmitted(false);
			});
		} else {
			setError("Please fill in all required fields correctly.");
			setSubmitted(false);
		}
	};

	return (
		<section id="appointment" className="appointment">
			<h2>Book an Appointment</h2>
			<form className="appointment-form" onSubmit={handleSubmit} autoComplete="off">
				<div className="form-group">
					<label htmlFor="name">Full Name</label>
					<input type="text" id="name" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} required />
				</div>
				<div className="form-group">
					<label htmlFor="email">Email Address</label>
					<input type="email" id="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} required />
				</div>
				<div className="form-group">
					<label htmlFor="phone">Phone Number</label>
					<input type="tel" id="phone" name="phone" placeholder="Enter your phone number" value={formData.phone} onChange={handleChange} required />
				</div>
				<div className="form-group">
					<label htmlFor="date">Preferred Date</label>
					<input type="date" id="date" name="date" value={formData.date} onChange={handleChange} required />
				</div>
				{error && <div className="form-error">{error}</div>}
				{submitted && <div className="form-success">Thank you! Your appointment request has been sent.</div>}
				<button type="submit" className="btn-primary">Submit</button>
			</form>
		</section>
	);
}


export default AppointmentForm;

/*
EmailJS Template Example (template_biokare):

Subject: New Appointment Request

Body:
Name: {{name}}
Email: {{email}}
Phone: {{phone}}
Preferred Date: {{date}}

You can set these variables in the EmailJS template editor. The 'to_email' param is optional if you set the recipient in the template settings.
*/